import React from "react";
import Nav from "../nav";
import {
  FaChevronDown,
  FaPlus,
  FaTrash,
  FaCopy,
  FaCalendarPlus,
  FaEllipsisH,
} from "react-icons/fa";

import { SiGooglesheets } from "react-icons/si";

const ShiftTopBar = ({
  selectedTimeSchema,
  handleChangeTimeSchema,
  allTimeSchemas,

  viewMode,
  setViewMode,

  currentDate,
  setCurrentDate,

  changeWeek,
  fetchShiftsForMonth,

  showCalendar,
  setShowCalendar,

  selectedCalendarDate,
  setSelectedCalendarDate,

  calendarRef,
  goToDate,

  inputValue,
  setInputValue,

  projectInputValue,
  setProjectInputValue,

  allEmployees,
  allProjects,

  selectedEmployee,
  setSelectedEmployee,

  selectedProject,
  setSelectedProject,

  lastPublishedDate,

  canEditShifts,
  setPublishPopupVisible,

  handleHoverIn,
  handleHoverOut,

  setSelectEmployeePopupVisible,
  setIsEditing,

  setDeleteMode,
  deleteMode,

  setShowCopyWeekPopup,

  setDeleteType,
  deleteType,

  selectedShiftIds,
  selectedDates,

  setSelectedShiftIds,
  setSelectedDates,

  handleBulkDelete,

  setShowCreateTimeSchemaPopup,

  moreButtonRef,

  setMoreMenuPosition,
  setShowMoreMenu,

  showMoreMenu,
  moreMenuPosition,

  company,

  setImportExcelPopupVisible,
  setShowTrashPopup,
}) => {



    const getWeekNumber = (date) => {
        const firstDayOfYear = new Date(date.getFullYear(), 0, 1);
        const pastDaysOfYear = (date - firstDayOfYear) / 86400000;
        return Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
    };


    return(
    <>
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "20px 0px",
        overflowX: "auto",
        overflowY: "hidden",
        whiteSpace: "nowrap",
        boxSizing: "border-box",
        flexWrap: "nowrap",
      }}
    >
      {/* Schema-select */}
      <div
        style={{
          position: "relative",
          display: "inline-block",
          flex: "0 1 220px",
          minWidth: 140,
          maxWidth: 260,
        }}
      >
        <select
          value={selectedTimeSchema}
          onChange={handleChangeTimeSchema}
          aria-label="Välj tidschema"
          style={{
            width: "100%",
            height: 50,
            padding: "8px 34px 8px 12px",
            border: "1px solid #d1d5db",
            borderRadius: 3,
            background: "#ffffff",
            fontSize: 14,
            color: "#111827",
            appearance: "none",
            MozAppearance: "none",
            WebkitAppearance: "none",
            outline: "none",
            boxSizing: "border-box",
            fontWeight: 500,
          }}
        >
          <option value="" disabled>
            -- ej valt --
          </option>
          {allTimeSchemas.map((schema, index) => (
            <option key={schema._id || index} value={schema._id}>
              {schema.name}
            </option>
          ))}
        </select>
        <FaChevronDown
          style={{
            position: "absolute",
            right: 10,
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            fontSize: 12,
            color: "#6b7280",
          }}
        />
        <span
          style={{
            position: "absolute",
            top: -8,
            left: 6,
            fontSize: "0.7rem",
            background: "#ffffff",
            padding: "0 4px",
            color: "#555960",
            userSelect: "none",
          }}
        >
          Schema
        </span>
      </div>

      {/* Pil + datum + pil – PILAR PRECIS INTILL DATUMBOXEN */}
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 2,
          flexShrink: 0,
        }}
      >
        {/* Vänster pil */}
        <button
          onClick={() => {
            if (viewMode === "week") {
              changeWeek(-1);
            } else {
              const newDate = new Date(currentDate);
              newDate.setMonth(newDate.getMonth() - 1);
              setCurrentDate(newDate);
              fetchShiftsForMonth(
                newDate.getMonth() + 1,
                newDate.getFullYear()
              );
            }
          }}
          style={{
            cursor: "pointer",
            padding: "0 10px",
            border: "1px solid #d1d5db",
            borderRadius: 3,
            background: "#ffffff",
            fontSize: 20,
            color: "#111827",
            width: 46,
            height: 50,
            textAlign: "center",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            userSelect: "none",
            flexShrink: 0,
          }}
        >
          &larr;
        </button>

        {/* Period-visning (trigger för kalender) */}
        <div
          id="period-trigger"
          style={{
            position: "relative",
            display: "inline-block",
            flex: "0 1 260px",
            minWidth: 240,
            maxWidth: 320,
          }}
        >
          <div
            style={{
              cursor: "pointer",
              padding: "10px 16px",
              border: "1px solid #d1d5db",
              borderRadius: 3,
              background: "#ffffff",
              fontSize: 15,
              color: "#111827",
              width: "100%",
              textAlign: "center",
              height: 50,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              boxSizing: "border-box",
              fontWeight: 500,
              userSelect: "none",
              gap: 0,
            }}
            onClick={() => setShowCalendar(!showCalendar)}
          >
            {viewMode === "week"
              ? `Vecka ${getWeekNumber(currentDate)}, ${
                  currentDate
                    .toLocaleString("sv-SE", { month: "long" })
                    .charAt(0)
                    .toUpperCase() +
                  currentDate
                    .toLocaleString("sv-SE", { month: "long" })
                    .slice(1)
                } ${currentDate.getFullYear()}`
              : `${
                  currentDate
                    .toLocaleString("sv-SE", { month: "long" })
                    .charAt(0)
                    .toUpperCase() +
                  currentDate
                    .toLocaleString("sv-SE", { month: "long" })
                    .slice(1)
                } ${currentDate.getFullYear()}`}
          </div>
        </div>

        {/* Höger pil */}
        <button
          onClick={() => {
            if (viewMode === "week") {
              changeWeek(1);
            } else {
              const newDate = new Date(currentDate);
              newDate.setMonth(newDate.getMonth() + 1);
              setCurrentDate(newDate);
              fetchShiftsForMonth(
                newDate.getMonth() + 1,
                newDate.getFullYear()
              );
            }
          }}
          style={{
            cursor: "pointer",
            padding: "0 10px",
            border: "1px solid #d1d5db",
            borderRadius: 3,
            background: "#ffffff",
            fontSize: 20,
            color: "#111827",
            width: 46,
            height: 50,
            textAlign: "center",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            userSelect: "none",
            flexShrink: 0,
          }}
        >
          &rarr;
        </button>
      </div>

      {/* Vecka / Månad toggle – ska ALLTID synas */}
      <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10,
        height: 50,
        width: 150,
        paddingLeft: 12,
        paddingRight: 12,
        borderRadius: 6,
        border: "1px solid #e5e7eb",
        background: "#ffffff",
        fontSize: 13,
        flexShrink: 0,
        boxSizing: "border-box",
      }}
    >
      {/* Text: Veckovy / Månadsvy */}
      <span
        style={{
          fontSize: 13,
          fontWeight: 500,
          color: "#111827",
          textTransform: "none",
          whiteSpace: "nowrap",
        }}
      >
        {viewMode === "week" ? "Veckovy" : "Månadsvy"}
      </span>

      {/* Liten, neutral switch */}
      <button
        type="button"
        onClick={() => {
          const next = viewMode === "week" ? "month" : "week";
          setViewMode(next);
          if (next === "month") {
            fetchShiftsForMonth(
              currentDate.getMonth() + 1,
              currentDate.getFullYear()
            );
          }
        }}
        style={{
          position: "relative",
          width: 36,
          height: 20,
          borderRadius: 999,
          border: "1px solid #d1d5db",
          padding: 0,
          cursor: "pointer",
          background: "#f9fafb",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "flex-start",
          boxSizing: "border-box",
        }}
      >
        <span
          style={{
            position: "absolute",
            left: viewMode === "week" ? 2 : 18,
            width: 16,
            height: 16,
            borderRadius: "50%",
            background: "#e5e7eb",
            boxShadow: "0 1px 2px rgba(0,0,0,0.15)",
            transition: "left 140ms ease-out",
          }}
        />
      </button>
    </div>




      {/* Filter: Användare */}
      <div
        style={{
          position: "relative",
          display: "inline-block",
          flex: "0 1 220px",
          minWidth: 150,
          maxWidth: 240,
        }}
      >
        <input
          list="userList"
          value={inputValue}
          onChange={(e) => {
            setInputValue(e.target.value);
            const found = allEmployees.find(
              (emp) => emp.name === e.target.value
            );
            setSelectedEmployee(found ? found._id : "");
          }}
          placeholder="Användare"
          style={{
            width: "100%",
            height: 50,
            padding: "8px 32px 8px 12px",
            border: "1px solid #d1d5db",
            borderRadius: 3,
            background: "#ffffff",
            fontSize: 14,
            color: "#111827",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
        <datalist id="userList">
          <option value="-- Alla Användare --" />
          {allEmployees.map((emp) => (
            <option key={emp._id} value={emp.name} />
          ))}
        </datalist>
        <FaChevronDown
          style={{
            position: "absolute",
            right: 10,
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            fontSize: 11,
            color: "#6b7280",
          }}
        />
      </div>

      {/* Filter: Projekt */}
      <div
        style={{
          position: "relative",
          display: "inline-block",
          flex: "0 1 230px",
          minWidth: 150,
          maxWidth: 260,
        }}
      >
        <input
          list="projectList"
          value={projectInputValue}
          onChange={(e) => {
            setProjectInputValue(e.target.value);
            const found = allProjects.find(
              (proj) => proj.name === e.target.value
            );
            setSelectedProject(found ? found._id : "");
          }}
          placeholder="Projekt"
          style={{
            width: "100%",
            height: 50,
            padding: "8px 32px 8px 12px",
            border: "1px solid #d1d5db",
            borderRadius: 3,
            background: "#ffffff",
            fontSize: 14,
            color: "#111827",
            outline: "none",
            boxSizing: "border-box",
          }}
        />
        <datalist id="projectList">
          <option value="-- Alla Projekt --" />
          {allProjects.map((proj, idx) => (
            <option key={proj._id || idx} value={proj.name} />
          ))}
        </datalist>
        <FaChevronDown
          style={{
            position: "absolute",
            right: 10,
            top: "50%",
            transform: "translateY(-50%)",
            pointerEvents: "none",
            fontSize: 11,
            color: "#6b7280",
          }}
        />
      </div>

      {/* Publicerat fram t.o.m */}
      <div
        style={{
          position: "relative",
          display: "inline-block",
          flex: "0 1 230px",
          minWidth: 150,
          maxWidth: 260,
        }}
      >
        <span
          style={{
            position: "absolute",
            top: -8,
            left: 6,
            fontSize: "0.7rem",
            background: "#ffffff",
            padding: "0 4px",
            color: "#555960",
            userSelect: "none",
          }}
        >
          Publicerat fram t.o.m
        </span>
          <button
            onClick={() => {
              if (!canEditShifts) return;
              setPublishPopupVisible(true);
            }}
            disabled={!canEditShifts}
            style={{
              width: "100%",
              height: 50,
              padding: "8px 12px",
              borderRadius: 3,
              border: "1px solid #d1d5db",
              background: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxSizing: "border-box",

              // 🔒 Read-only styling
              cursor: canEditShifts ? "pointer" : "not-allowed",
              opacity: canEditShifts ? 1 : 0.45,
              pointerEvents: canEditShifts ? "auto" : "none",
            }}
            title={!canEditShifts ? "Du har endast läsbehörighet" : undefined}
          >
            <span
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#111827",
                userSelect: "none",
              }}
            >
              {lastPublishedDate}
            </span>
          </button>
      </div>

      {/* Actions: +pass, nytt schema, import */}
      <div style={{ display: "inline-flex", alignItems: "center", gap: 8, flexShrink: 0, position: "relative" }}>

        {/* + PASS */}
        {canEditShifts && (
          <button
            onMouseEnter={handleHoverIn}
            onMouseLeave={handleHoverOut}
            onClick={() => { setSelectEmployeePopupVisible(true); setIsEditing(false); }}
            style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 42, height: 42, borderRadius: 8, background: "#2563eb", color: "white", fontSize: 18, border: "1px solid #1d4ed8", cursor: "pointer" }}
          >
            <FaPlus />
          </button>
        )}


        {/* DELETE */}
        <button
          onMouseEnter={handleHoverIn}
          onMouseLeave={handleHoverOut}
          onClick={() => {
            if (!canEditShifts) return;
            setDeleteMode(true);
            setDeleteType("shift");
            setSelectedShiftIds(new Set());
            setSelectedDates(new Set());
          }}
          style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", width: 42, height: 42, borderRadius: 8, background: "#fb2e2e", color: "white", fontSize: 18, border: "1px solid #b91c1c", cursor: canEditShifts ? "pointer" : "not-allowed", opacity: canEditShifts ? 1 : 0.45 }}
        >
          <FaTrash />
        </button>

        {/* TIME SCHEMA */}
        <button
          onMouseEnter={handleHoverIn}
          onMouseLeave={handleHoverOut}
          onClick={() => { if (!canEditShifts) return; setShowCreateTimeSchemaPopup(true); }}
          style={{ 
             display: "inline-flex",
             alignItems: "center",
             justifyContent: "center",
             width: 42,
             height: 42,
             borderRadius: 8,
             background: "#3b82f6",
             color: "white",
             fontSize: 18,
             border: "1px solid #2563eb",
             cursor: canEditShifts ? "pointer" : "not-allowed",
             opacity: canEditShifts ? 1 : 0.45
            }}
        >
          <FaCalendarPlus />
        </button>


        {/* MORE */}
        <button
          ref={moreButtonRef}
          onMouseEnter={handleHoverIn}
          onMouseLeave={handleHoverOut}
          onClick={(e) => {
            if (!canEditShifts) return; // 🔥 block click

            e.stopPropagation();

            const rect = moreButtonRef.current.getBoundingClientRect();

            setMoreMenuPosition({
              top: rect.bottom + 6,
              left: rect.right - 180,
            });

            setShowMoreMenu(prev => !prev);
          }}
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 42,
            height: 42,
            borderRadius: 8,
            background: "#111827",
            color: "white",
            fontSize: 16,
            border: "1px solid #1f2937",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            cursor: canEditShifts ? "pointer" : "not-allowed", // 🔥
            opacity: canEditShifts ? 1 : 0.45,                 // 🔥
          }}
        >
          <FaEllipsisH />
        </button>

        {/* DROPDOWN */}
        {showMoreMenu && (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "fixed",
              top: moreMenuPosition.top,
              left: moreMenuPosition.left,
              background: "#ffffff",
              border: "1px solid #e5e7eb",
              borderRadius: 10,
              boxShadow: "0 10px 30px rgba(0,0,0,0.12)",
              padding: 6,
              minWidth: 180,
              zIndex: 999999999
            }}
          >
            {/* EXCEL */}
            {
              company.showExcelShiftImport && (
                <div
                  onClick={() => { setShowMoreMenu(false); if (!canEditShifts) return; setImportExcelPopupVisible(true); }}
                  style={{ display: "flex", alignItems: "center", padding: "8px 10px", borderRadius: 8, fontSize: 13, cursor: "pointer", color: "#111827" }}
                >
                  <SiGooglesheets style={{ marginRight: 8 }} />
                  Importera Excel
                </div>
              ) 
            }

          <div
            onClick={() => {
              setShowMoreMenu(false);
              setShowCopyWeekPopup(true);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              padding: "8px 10px",
              borderRadius: 8,
              fontSize: 13,
              cursor: "pointer",
              color: "#111827"
            }}
          >
            <FaCopy style={{ marginRight: 8 }} />
            Kopiera vecka
          </div>


            {/* TRASH */}
            <div
              onClick={() => {
                setShowMoreMenu(false);
                setShowTrashPopup(true);
              }}
              style={{ display: "flex", alignItems: "center", padding: "8px 10px", borderRadius: 8, fontSize: 13, cursor: "pointer", color: "#111827" }}
            >
              <FaTrash style={{ marginRight: 8 }} />
              Papperskorg
            </div>
          </div>
        )}
      </div>
    </div>

    {deleteMode && (
      <div
        style={{
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #e5e7eb",
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: 16,
          boxSizing: "border-box",
        }}
      >
        {/* LEFT: MODE + COUNT */}
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          
          {/* TYPE SWITCH (pill style) */}
          <div
            style={{
              display: "flex",
              background: "#f3f4f6",
              borderRadius: 8,
              padding: 3,
            }}
          >
            {["shift", "day"].map((type) => {
              const active = deleteType === type;
              return (
                <button
                  key={type}
                  onClick={() => {
                    setDeleteType(type);
                    setSelectedShiftIds(new Set());
                    setSelectedDates(new Set());
                  }}
                  style={{
                    padding: "6px 12px",
                    borderRadius: 6,
                    border: "none",
                    cursor: "pointer",
                    background: active ? "#ef4444" : "transparent",
                    color: active ? "white" : "#374151",
                    fontWeight: 600,
                    fontSize: 13,
                    transition: "all 120ms ease",
                  }}
                >
                  {type === "shift" ? "Pass" : "Dagar"}
                </button>
              );
            })}
          </div>

          {/* COUNT */}
          <div
            style={{
              fontSize: 14,
              fontWeight: 600,
              color: "#111827",
            }}
          >
            {deleteType === "shift"
              ? `${selectedShiftIds.size} pass valda`
              : `${selectedDates.size} dagar valda`}
          </div>
        </div>

        {/* PUSH RIGHT */}
        <div style={{ flex: 1 }} />

        {/* RIGHT SIDE ACTIONS */}
        <div style={{ display: "flex", gap: 8 }}>
          
          {/* CANCEL */}
          <button
            onClick={() => {
              setDeleteMode(false);
              setSelectedShiftIds(new Set());
              setSelectedDates(new Set());
            }}
            style={{
              padding: "8px 14px",
              borderRadius: 8,
              border: "1px solid #d1d5db",
              background: "#ffffff",
              color: "#111827",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: 13,
            }}
          >
            Avbryt
          </button>

          {/* DELETE */}
          <button
            onClick={handleBulkDelete}
            style={{
              padding: "8px 14px",
              borderRadius: 8,
              border: "none",
              background: "#ef4444",
              color: "white",
              cursor: "pointer",
              fontWeight: 700,
              fontSize: 13,
              boxShadow: "0 2px 6px rgba(239,68,68,0.25)",
            }}
          >
            Radera
          </button>
        </div>


      </div>
    )}





    {/* ✅ KALENDER-POPUP – SAMMA SOM INNAN */}
    {showCalendar &&
      (() => {
        const r = document
          .getElementById("period-trigger")
          ?.getBoundingClientRect();
        const top = (r?.bottom ?? 80) + window.scrollY;
        const left = (r?.left ?? 20) + window.scrollX;
        const width = r?.width ?? 300;

        return (
          <div
            ref={calendarRef}
            style={{
              position: "fixed",
              top,
              left,
              width,
              background: "#ffffff",
              border: "1px solid #d1d5db",
              borderRadius: 8,
              padding: 10,
              zIndex: 3000,
              boxSizing: "border-box",
              boxShadow: "0 18px 40px rgba(15,23,42,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <input
              type="date"
              value={selectedCalendarDate || ""}
              onChange={(e) => { goToDate(e.target.value); setSelectedCalendarDate(e.target.value); }}
              style={{
                width: "100%",
                padding: "8px 10px",
                border: "1px solid #d1d5db",
                borderRadius: 6,
                fontSize: 13,
                marginBottom: 8,
                outline: "none",
                boxSizing: "border-box",
                background: "#ffffff",
                color: "#111827",
              }}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: 8,
              }}
            >
              <button
                onClick={() => {
                  if (!selectedCalendarDate) return;
                  goToDate(selectedCalendarDate);
                  setShowCalendar(false);
                }}
                style={{
                  flex: 1,
                  padding: "8px 8px",
                  background: "#2563eb",
                  color: "white",
                  border: "none",
                  borderRadius: 6,
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: 13,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  outline: "none",
                  userSelect: "none",
                }}
              >
                Gå till datum
              </button>
              <button
                onClick={() => {
                  goToDate(new Date());
                  setSelectedCalendarDate(null);
                  setShowCalendar(false);
                }}
                style={{
                  flex: 1,
                  padding: "8px 8px",
                  background: "#f3f4f6",
                  color: "#111827",
                  border: "1px solid #d1d5db",
                  borderRadius: 6,
                  cursor: "pointer",
                  fontWeight: 600,
                  fontSize: 13,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  outline: "none",
                  userSelect: "none",
                }}
              >
                Idag
              </button>
            </div>
          </div>
        );
      })()}
      </>
    )


}


export default ShiftTopBar;